module.exports = __webpack_public_path__ + "img/impostor-knife-alien.6eed693c.png";